export default __webpack_public_path__ + "static/portal-f6c67e55dd384c8323fd19c1dfac45c3.webm";